export default {
	stylus: require('./stylus').default
};